import { api } from 'api'

type GetWhoamiResponseCompanyGroup = {
  id: number
  name: string
}

type GetWhoamiResponseCompany = {
  isDefault: boolean
  companyId: number
  companyName: string
  companyGroup: GetWhoamiResponseCompanyGroup | null
  permissionId: number
  isInternalWorkforceEnabled: boolean
  logoUrl: string | null
  takePercentageEstimate: string | number
  bonusTakePercentageEstimate: string | number
  chargeUpfront: boolean
  w2: boolean
  backfillPolicy: boolean
  hasVNDLYIntegration: boolean
}

type GetWhoamiResponsePermission = {
  id: number
  name: string
  description: string
  manageBonus: boolean
  manageRoles: boolean
  manageShift: boolean
  manageWorker: boolean
  messageWorker: boolean
  paymentAccess: boolean
  requestSpecificWorker: boolean
  workTimeAdjustment: boolean
}

type GetWhoamiResponse = {
  companies: GetWhoamiResponseCompany[]
  permissions: GetWhoamiResponsePermission[]
}

export async function getWhoami() {
  const response = await api.get<GetWhoamiResponse>('/company/actor/whoami')
  return response.data
}
